import React, {useState} from 'react'
import {Button, message, Modal, Popconfirm, Select} from 'antd';
import {isolationNumberByTenant} from "../../../../../../services/api/apiCustomerHub";
import parseToken from "../../../../../../helpers/parseToken";
import {Option} from "antd/es/mentions";

function IsolationNumberModal(props) {
    const {showModal, toggleModal, custId, listTelco, fetchListTenantNumber, shortPhone} = props
    const decodeToken = parseToken()
    const [telco, setTelco] = useState('')
    const [phone, setPhone] = useState(shortPhone.length === 1 ? shortPhone[0].name : '')
    const [telcoCalled, setTelcoCalled] = useState('')
    const [loading, setLoading] = useState(false)
    const [validate, setValidate] = useState({})

    const handleCancel = () => {
        toggleModal()
    }

    const onChangeTelco = (value) => {
        setTelco(value)
    }

    const onChangeShortPhone = (value) => {
        setPhone(value)
    }

    const onChangeTelcoCalled = (value) => {
        setTelcoCalled(value)
    }

    const onValidate = () => {
        setValidate({
            telco: telco ? '' : 'Vui lòng chọn Mạng',
            phone: phone ? '' : 'Vui lòng chọn Số ảo',
            telcoCalled: telcoCalled ? '' : 'Vui lòng chọn Hướng gọi',
        })
        if (!telco || !phone || !telcoCalled) {
            return false
        }
        return true
    }

    const onIsolationNumber = async () => {
        if (!onValidate()) {
            message.error('Vui lòng nhập đầy đủ thông tin!')
            return
        }
        try {
            const payload = {
                telco,
                shortPhone: phone,
                telcoCalled,
                tenantId: custId
            }
            const response = await isolationNumberByTenant(decodeToken.sub, payload)
            const {success, error_message} = response
            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error_message)
            }
            message.success('Cô lập thành công!')
            toggleModal()
            fetchListTenantNumber()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    return <Modal
        title="Cô lập"
        className={`ModalCustom2`}
        style={{top: 20}}
        maskClosable={false}
        open={showModal}
        footer={[
            <div className="Actions d-flex justify-content-end align-items-center">
                <Popconfirm placement="top" title="Bạn chắc chắn cô lập ko?" onConfirm={onIsolationNumber} okText="Yes"
                            cancelText="No">
                    <Button key="submit" type="primary" loading={loading}>
                        Cô lập
                    </Button>
                </Popconfirm>
                <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleCancel} okText="Yes"
                            cancelText="No">
                    <Button key="back" type="link" disable={loading}>
                        Cancel
                    </Button>
                </Popconfirm>
            </div>
        ]}
    >
        <div className="FormAddNew">
            <div className="row">
                <div className="FormField col-md-12 mb-3">
                    <label className="Label">
                        Chọn Mạng
                    </label>
                    <Select onChange={onChangeTelco} placeholder="Chọn" style={{width: '100%', minWidth: '150px'}}>
                        {
                            listTelco.map(item => {
                                return <Option value={item.code} key={item.code}>{item.name}</Option>
                            })
                        }
                    </Select>
                    {validate?.telco && <div className="mt-1 text-danger">{validate?.telco}</div>}
                </div>
                <div className="FormField col-md-12 mb-3">
                    <label className="Label">
                        Số ảo
                    </label>
                    <Select name="Số ảo" onChange={onChangeShortPhone} placeholder="Chọn"
                            style={{width: '100%', minWidth: '150px'}}>
                        {
                            shortPhone.map(item => {
                                return <Option value={item.name} key={item.name}>{item.label}</Option>
                            })
                        }
                    </Select>
                    {validate?.phone && <div className="mt-1 text-danger">{validate?.phone}</div>}
                </div>
                <div className="FormField col-md-12 mb-3">
                    <label className="Label">
                        Hướng gọi
                    </label>
                    <Select onChange={onChangeTelcoCalled} placeholder="Chọn"
                            style={{width: '100%', minWidth: '150px'}}>
                        {
                            listTelco.map(item => {
                                return <Option value={item.code} key={item.code}>{item.name}</Option>
                            })
                        }
                    </Select>
                    {validate?.telcoCalled && <div className="mt-1 text-danger">{validate?.telcoCalled}</div>}
                </div>
            </div>
        </div>
    </Modal>
}

export default IsolationNumberModal
